import performRequest from "network/perform-request";

export const triggerBrowserDownload = (blob, filename) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};

export const downloadAuthenticatedFile = async ({
  method = "GET",
  url,
  params = {},
  user,
  filename,
  accept = "application/octet-stream",
  responseType = "blob",
}) => {
  const response = await performRequest(method, url, params, true, user, null, { Accept: accept }, false, responseType);
  const contentType = response.headers["content-type"] || accept;
  const blob = new Blob([response.data], { type: contentType });
  triggerBrowserDownload(blob, filename);
};
